import React from 'react';
import { TEAM } from '../siteData';
import { useSiteContent } from '../SiteContent';
import T from './EditableText';

/**
 * Teamübersicht — auf Startseite und „Über uns“ identisch.
 *
 * Bilder und Reihenfolge stehen in `siteData.ts`, Name und Aufgabe als
 * `team.N.name` bzw. `team.N.rolle` in `content/stammdaten.ts`. Die Nummer ergibt
 * sich aus der Position: Wer jemanden einfügt oder entfernt, verschiebt damit die
 * Zuordnung der bereits geänderten Texte und muss sie einmal durchsehen.
 */
const TeamGrid: React.FC = () => {
  const { t } = useSiteContent();

  return (
    <div className="autogrid" style={{ ['--min' as string]: '180px' }}>
      {TEAM.map((member, index) => (
        <div className="person" key={member.image}>
          <img src={member.image} alt={t(`team.${index + 1}.name`)} loading="lazy" width={520} height={620} />
          <div className="person-name">
            <T k={`team.${index + 1}.name`} />
          </div>
          <div className="person-role">
            <T k={`team.${index + 1}.rolle`} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default TeamGrid;
